import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import styles from "./css/ChildDetails.module.css";
import { EditChildForm } from "../components/children/EditChild";
import { Paths } from "../routes/paths";
// import { UserHeader } from "../components/UserHeader";
//
// import { useFeatures } from "../auth/useFeatures";
import { FEATURES } from "../routes/features";
import { FeatureButton } from "../components/FeatureButton";
// //
import { baseURL } from "../services/axios";
import { useAppSelector } from "../redux/store";
import { selectHasFeature } from "../redux/features";

// import { ChildForms } from "../components/children/ChildForms"; // נניח שיש קומפוננטה לטפסים

export const ChildDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [child, setChild] = useState<any>(null);
  const [error, setError] = useState("");
  const [view, setView] = useState<"menu" | "notes" | "forms">("menu");
  const [isEditing, setIsEditing] = useState(false);
const canAddChild = useAppSelector(selectHasFeature(FEATURES.ADD_CHILD));
  useEffect(() => {
      console.log("Child ID from URL:", id);
    const fetchChild = async () => {
        console.log("id שהתקבל מה-URL:", id);
      try {
        const response = await fetch(`${baseURL}/child/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        if (!response.ok) {
          const text = await response.text();
          setError(text);
          return;
        }

        const data = await response.json();
        setChild(data);
      } catch (err) {
        setError("שגיאה בעת טעינת הנתונים.");
      }
    };

    fetchChild();
  }, [id]);

  const handleSave = async (updatedChild: any) => {
    try {
      const response = await fetch(`/child/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(updatedChild),
      });

      if (!response.ok) {
        const text = await response.text();
        setError(text);
        return;
      }

      setChild(updatedChild);
      setIsEditing(false);
    } catch {
      setError("שגיאה בעת שמירת הנתונים.");
    }
  };
console.log("isEditing:", isEditing);

  if (error) return <p className={styles.error}>{error}</p>;
  if (!child) return <p className={styles.loading}>טוען פרטי ילד...</p>;

  return (
    <>
      {/* <UserHeader /> */}
      <div className={styles.pageContainer}>
      <div className={styles.container}>
      {view !== "notes" && (
        <div className={styles.childHeader}>
          <div className={styles.childNameWrapper}>
            <h2 className={styles.childName}>
              {child.fname} {child.lname}
            </h2>
            {/* {!isEditing && (
              <button className={`${styles.editButton} ${styles.buttonBrown}`} onClick={() => setIsEditing(true)}>
                <i className="fas fa-user-edit"></i>
                <span>ערוך פרטים</span>
              </button>
            )} */}
{!isEditing && (
  <FeatureButton
    feature={FEATURES.EDIT_CHILD_PROFILE}
    className={`${styles.editButton} ${styles.buttonBrown}`}
    onClick={() => setIsEditing(true)}
  >
    <i className="fas fa-user-edit"></i>
    <span>ערוך פרטים</span>
  </FeatureButton>
)}


          </div>
        </div>
      )}

      {isEditing ? (
        <EditChildForm child={child} onCancel={() => setIsEditing(false)} onSave={handleSave} />
      ) : (
        <>
          {view === "menu" && (
            <div className={styles.menuButtons}>
              {/* <button 
                className={`${styles.mainButton} ${styles.buttonPeach}`} 
                onClick={() =>
                  navigate(
                    `/${Paths.childForms.replace(":id", child.code)}`,
                    { 
                      state: { childName: `${child.fname} ${child.lname}` }
                    }
                  )
                }
              >
                <span className={styles.buttonContent}>
                  <i className="fas fa-file-alt"></i>
                  <span className={styles.buttonText}>טפסים</span>
                </span>
              </button> */}
              <button
  className={`${styles.mainButton} ${styles.buttonBrown} ${!canAddChild ? styles.disabled : ""}`}
  disabled={!canAddChild}
  onClick={() => {
    if (!canAddChild) return; 
    
    navigate(
      `/${Paths.childNotes.replace(":id", child.code)}`,
      { state: { childName: `${child.fname} ${child.lname}` } }
    );
  }}
>
  <span className={styles.buttonContent}>
    <i className="fas fa-file-alt"></i>
    <span className={styles.buttonText}>טפסים</span>
  </span>
</button>

              <button 
                className={`${styles.mainButton} ${styles.buttonBrown}`} 
                onClick={() =>
                  navigate(
                    `/${Paths.childNotes.replace(":id", child.code)}`,
                    { 
                      state: { childName: `${child.fname} ${child.lname}` }
                    }
                  )
                }
              >
                <span className={styles.buttonContent}>
                  <i className="fas fa-sticky-note"></i>
                  <span className={styles.buttonText}>תוכניות עבודה</span>
                </span>
              </button>
              <button 
                className={`${styles.mainButton} ${styles.buttonDarkBrown}`} 
                onClick={() =>
                  navigate(
                    `/${Paths.lessonSummaries.replace(":id", child.code)}`,
                    { 
                      state: { childName: `${child.fname} ${child.lname}` }
                    }
                  )
                }
              >
                <span className={styles.buttonContent}>
                  <i className="fas fa-book"></i>
                  <span className={styles.buttonText}>סיכומי שיעור</span>
                </span>
              </button>
              <button
                className={`${styles.mainButton} ${styles.buttonDarkGreen}`}
                onClick={() =>
                  navigate(
                    `/${Paths.behaviorAnalysis.replace(":id", child.code)}`,
                    { 
                      state: { childName: `${child.fname} ${child.lname}` }
                    }
                  )
                }
              >
                <span className={styles.buttonContent}>
                  <i className="fas fa-chart-line"></i>
                  <span className={styles.buttonText}>ניתוח התנהגות</span>
                </span>
              </button>
              <button 
                className={`${styles.mainButton} ${styles.buttonBlue}`}
                onClick={() =>
                  navigate(
                    `/${Paths.generalSummary.replace(":id", child.code)}`,
                    { 
                      state: { childName: `${child.fname} ${child.lname}` }
                    }
                  )
                }
              >
                <span className={styles.buttonContent}>
                  <i className="fas fa-info-circle"></i>
                  <span className={styles.buttonText}>סיכום כללי</span>
                </span>
              </button>
            </div>
          )}

          {/* {view === "notes" && <ChildNotes childCode={child.code} childName={`${child.fname} ${child.lname}`} />} */}
          {/* {view === "forms" && <ChildForms childId={child.id} />} */}
        </>
      )}

      {/* הסרנו את כפתור החזרה לרשימת הילדים */}
    </div>
    </div>
    
    </>
  );
};
